export const activityLogHistories = (
  activityHistories = [],
  activities = [],
  updateActivities = []
) => {
       const activityMap = new Map(
         activities.map(a => [a.value, a.description])
       )
       const updateActivityMap = new Map(
         updateActivities.map(a => [a.value, a.value])
       )

       const formatHistory = (it, activity) => ({
         id: it.id,
         staff: it.staff ? `${it.staff.lastname} ${it.staff.firstname}` : '',
         createdAt: it.createdAt,
         activity,
       })

       return {
         updateActivityHistories: activityHistories
           .filter(it => activityMap.has(it.activity))
           .map(it => formatHistory(it, activityMap.get(it.activity))),

         postActivityHistories: activityHistories
           .filter(it => updateActivityMap.has(it.activity))
           .map(it => formatHistory(it, updateActivityMap.get(it.activity))),
       }
     }
